import { onReady } from '../../shared/utils/helpers';
import Base from '../../components/base/base';
import Header from '../../components/header/header';
import PageLoader from '../../components/page-loader/page-loader';
import './about.scss';

interface AboutPageOptions {
  debug?: boolean;
  [key: string]: any;
}

class AboutPage extends Base {
  private header: Header;

  private loader: PageLoader;

  constructor(options: AboutPageOptions = {}) {
    super(options.debug || false);
    this.debug = options.debug || false;

    this.header = new Header({ debug: this.debug });
    this.loader = new PageLoader({
      debug: this.debug,
      oncePerPageSession: true,
      pageKey: window.location.pathname,
    });

    this.init();
  }

  init(): void {
    this.loader.start();
    this.log('AboutPage initialized');
  }
}

onReady(() => {
  new AboutPage({ debug: true });
});

export default AboutPage;
